var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 6.5H9.49395C8.87617 8.2478 7.20933 9.5 5.25 9.5C2.76472 9.5 0.75 7.48527 0.75 5C0.75 2.51472 2.76472 0.5 5.25 0.5C7.20933 0.5 8.87617 1.75222 9.49395 3.5H17.25V6.5H15.75V9.5H12.75V6.5ZM5.25 6.5C6.07843 6.5 6.75 5.82845 6.75 5C6.75 4.17155 6.07843 3.5 5.25 3.5C4.42157 3.5 3.75 4.17155 3.75 5C3.75 5.82845 4.42157 6.5 5.25 6.5Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.044cb726c3d9ca2d8439523e3743e636.svg";
export { ForwardRef as ReactComponent };